import React, { ReactElement } from 'react';

interface Props {
    isMenuOpen: boolean;
    children: any;
}

const MobileMenu: React.FC<Props> = (props: Props) : ReactElement => {
  return (
    <div className={`modal ${props.isMenuOpen ? 'display-block' : 'display-none'}`}>
      <section className='modal-main'>
        {props.children}
      </section>
    </div>
  );
};

export default MobileMenu;
